import {
  colorBackgroundAlt,
  colorBackgroundDefault,
  colorBrandPrimaryDefault,
  colorContentDefaultInverse,
  colorOutlineSoftest,
  colorStatusAlertBold,
  colorStatusAlertSoftest,
  colorStatusNeutralBold,
  colorStatusNeutralSoftest,
  colorStatusNoticeDefault,
  colorStatusPositiveBold,
  colorStatusPositiveSoftest,
} from '@duxton-web/design-tokens/themes/light';

export const contentConfigStyleVars = {
  '--cc-background-alt': colorBackgroundAlt,
  '--cc-background-default': colorBackgroundDefault,
  // Grab brand green (#00b14f).
  '--cc-brand-primary-default': colorBrandPrimaryDefault,
  '--cc-content-default-inverse': colorContentDefaultInverse,
  '--cc-outline-softest': colorOutlineSoftest,
  '--cc-status-alert-bold': colorStatusAlertBold,
  '--cc-status-alert-softest': colorStatusAlertSoftest,
  '--cc-status-neutral-bold': colorStatusNeutralBold,
  '--cc-status-neutral-softest': colorStatusNeutralSoftest,
  '--cc-status-notice-default': colorStatusNoticeDefault,
  '--cc-status-positive-bold': colorStatusPositiveBold,
  '--cc-status-positive-softest': colorStatusPositiveSoftest,
};

export const contentConfigModalStyle = {
  ...contentConfigStyleVars,
  maxWidth: '96vw',
};

// Status chip styling for Product Offering versions. Shared so the status chip
// and the content-generation source picker always render the same tag.
export const PRODUCT_STATUS_TAG = {
  active: { color: 'success', label: 'ACTIVE' },
  pending: { color: 'processing', label: 'PENDING APPROVAL' },
  draft: { color: 'warning', label: 'DRAFT' },
};
